import React, { useState, useEffect } from "react";
import styles from "./FeaturedPhotographer.module.css";
import PhotographerCard from "./PhotographerCard";
import Images from "../../ALL_Images/Images.js";
import swal from "sweetalert";
import axios from "../../axios.js";
import { get } from "jquery";

const FeaturedPhotographer = (props) => {
  //? Dummy Photographer >>>>>>>>>>>>>>>>>>>
  // const photographers = [
  //   {
  //     name: "Himanshu Kesharwani",
  //     location: props.city,
  //     image_url: Images.Himanshukesharwani,
  //     displayImages: [
  //       Images.Mumbai,
  //       Images.kerala,
  //       Images.kolkata,
  //       Images.pune,
  //     ],
  //     intro:
  //       "sodales accumsan ligula. Aenean sed diam tristique, fermentum minec, ornare arch.",
  //   },

  //   {
  //     id: 2,
  //     name: "Himanshu Kesharwani",
  //     location: props.city,
  //     image_url: Images.Himanshukesharwani,
  //     displayImages: [
  //       Images.Mumbai,
  //       Images.kerala,
  //       Images.kolkata,
  //       Images.pune,
  //     ],
  //     intro:
  //       "sodales accumsan ligula. Aenean sed diam tristique, fermentum minec, ornare arch.",
  //   },

  //   {
  //     id: 3,
  //     name: "Himanshu Kesharwani",
  //     location: props.city,
  //     image_url: Images.Himanshukesharwani,
  //     displayImages: [
  //       Images.Mumbai,
  //       Images.kerala,
  //       Images.kolkata,
  //       Images.pune,
  //     ],
  //     intro:
  //       "sodales accumsan ligula. Aenean sed diam tristique, fermentum minec, ornare arch.",
  //   },
  // ];
  //? Dummy Photographer <<<<<<<<<<<<<<<<<<<

  // get Photographers List
  const [photographers, setPhotographers] = useState([]);

  // console.log('From FeaturedPhotographer: ' + props.city);

  const getPhotographersList = async () => {
    const reqcity = props.city || "";

    try {
      const res = await axios.get(`/photographer/list/${reqcity}`);
      console.log(res.data[0].photographers);
      setPhotographers(res.data[0].photographers);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    getPhotographersList();
  }, [1]);

  return (
    <>
      {photographers.map((photographer) => (
        <PhotographerCard
          // setPopupDisplay={props.setPopupDisplay}
          name={photographer.name}
          location={photographer.location}
          image_url={photographer.image_url}
          intro={photographer.intro}
          displayImages={photographer.displayImages_url}
        />
      ))}
    </>
  );
};

export default FeaturedPhotographer;
